import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { fetchClients, fetchFilterCounts } from "../../api/clientApi";
import * as Endpoints from "../../entities/Endpoints";


export const getClients = createAsyncThunk(
  Endpoints.GET_CLIENTS,
  async ({ coachId, sortOrder, page, pageSize, filter, searchKey }, { rejectWithValue }) => {
    try {
      const response = await fetchClients(coachId, sortOrder, page, pageSize, filter, searchKey);

      // Check if the response indicates failure
      if (!response.success) {
        return rejectWithValue(response?.data?.message); 
      }

      return response?.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "An unexpected error occurred."
      );
    }
  }
);

// Async thunk to fetch clients
export const getFilterCounts = createAsyncThunk(
  Endpoints.GET_CLIENTS_LIST_FILTER_OPTIONS,
  async ({ coachId }) => {
    const response = await fetchFilterCounts(coachId);
    return response.data;
  }
);

const clientSlice = createSlice({
  name: "clients",
  initialState: {
    clients: [],
    totalCount: 0,
    currentPage: 1,
    pageSize: 10,
    loading: false,
    error: null,
    filterCounts: null,
    filterLoading: false,
  },
  reducers: {
    setPagination: (state, action) => {
      const { page, pageSize } = action.payload;
      if (pageSize !== state.pageSize) {
        state.clients = [];
        state.currentPage = 1;
      } else {
        state.currentPage = page;
      }
      state.pageSize = pageSize;
    },
  },
  extraReducers: (builder) => {
    // For getClients
    builder
      .addCase(getClients.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getClients.fulfilled, (state, action) => {
        state.clients = action.payload.clients;
        state.totalCount = action.payload.totalCount;
        state.loading = false;
      })
      .addCase(getClients.rejected, (state, action) => {
        state.loading = false;
        state.clients = [];
        state.error = action.payload || "An unexpected error occurred.";
      });

    // For getFilterCounts
    builder
      .addCase(getFilterCounts.pending, (state) => {
        state.filterLoading = true;
      })
      .addCase(getFilterCounts.fulfilled, (state, action) => {
        state.filterCounts = action.payload;
        state.filterLoading = false;
      })
      .addCase(getFilterCounts.rejected, (state, action) => {
        state.filterLoading = false;
        state.error = action.error.message;
      });
  },
});

export const { setPagination } = clientSlice.actions;
export default clientSlice.reducer;
